<app-modal (dismiss)="reset()">
    <ng-container modal-header>
        <p>{{ 'admin.lifts.modal.title' | translate }}</p>
    </ng-container>
    <ng-container modal-body>
        <form [formGroup]="liftForm">

            <app-input
                [formControl]="liftForm.controls.name"
                [showErrors]="showValidations"
                [placeholder]="'admin.lifts.modal.input' | translate"
                label="{{ 'admin.lifts.modal.input' | translate }}">
            </app-input>

            <app-dropdown-autocomplete formControlName="plant"
                                       [formControl]="liftForm.controls.plant"
                                       [showErrors]="showValidations"
                                       [items]="plants"
                                       [appendTo]="'body'"
                                       name="plant"
                                       valueField="id"
                                       displayField="name"
                                       [label]="'admin.lines.create-modal.details.plant-input.label' | translate"
                                       [emptyText]="'admin.lines.create-modal.details.plant-input.placeholder' | translate">
            </app-dropdown-autocomplete>

        </form>
    </ng-container>
    <ng-container modal-footer>
        <app-button type="primary"
                    (click)="onConfirm()">{{ 'admin.lifts.modal.confirm' | translate }}
        </app-button>
    </ng-container>
</app-modal>
